export type Garage = {
	id: number,
	url: string,
	name: string,
	image: string,
	lat: number,
	lng: number,
	postal: string,
	city: string,
	street: string,
	country: string,
	position: Position,
	sharing_available: boolean,
	charging_available: boolean,
	parking_available: boolean,
	parking_car_spaces: number,
	charging_hubs: number,
	driveway_height: string,
	external_url?: string
	cheapest_short_parking_tariff_title?: string,
	cheapest_short_parking_tariff_formatted?: string,
	contracted_project: boolean,
	contracted_due_date: string
}

export type Position = {
	lat: number,
	lng: number,
}

export type ParkingSharingCharging = Record<CategoryType, string>;
export type ContractedParkingChargingSharing = Record<ContractedType, string>;

type _Facet = {
	count: number | false,
	url: string,
	isActive: boolean,
	isDisabled: boolean,
	value?: string,
};

export type Facet = Readonly<_Facet>;

export type FacetItem = Record<string, Facet[]>;

export type FacetGroup = Record<string, FacetItem>;

export enum CategoryType {
  CHARGING = 'charging',
  PARKING = 'parking',
  SHARING = 'sharing',
}

export enum ContractedType {
	PARKING_CONTRACTED = 'parking_contracted',
	CHARGING_CONTRACTED = 'charging_contracted',
	SHARING_CONTRACTED = 'sharing_contracted',
}

export enum GarageLiveStates {
	VACANT = 'vacant',
	FULL = 'full',
	NO_SHORT_STAY_PARKING = 'no_short_stay_parking',
	UNKNOWN = 'unknown',
}

export type GarageLiveStatusResponse = {
	status: GarageLiveStates,
	timestamp: int|null,
	ttl,
}